export const getErrorMessage = (error, fallback = "Something went wrong") => {
  if (!error) return fallback;

  const responseData = error?.response?.data;

  if (typeof responseData === "string") {
    return responseData;
  }

  return (
    responseData?.message ||
    responseData?.error?.message ||
    responseData?.error ||
    error.message ||
    fallback
  );
};
